<template>
  <div v-if="!tokenList.dirty && tokenList.data.length">
    <div class="text-xl font-bold text-text leading-tight mb-4">{{ $t('listTitle') }}</div>
    <div class="text-sm text-text-secondary">
      <div class="api-list-grid text-text-ternary font-medium py-2">
        <div>{{ $t('nameLabel') }}</div>
        <div>{{ $t('createdLabel') }}</div>
        <div>{{ $t('lastUseLabel') }}</div>
      </div>
      <div class="divide-y divide-border">
        <div v-for="(item,i) in tokenList.data" :key="i"
             class="api-list-grid py-2 group">
          <div>{{ item.name }}</div>
          <div>{{ $moment.unix(item.created_at).locale($i18n.locale).format('DD.MM.YYYY HH:MM') }}</div>
          <div>
            {{ item.used_at ? $moment.unix(item.used_at).locale($i18n.locale).format('DD.MM.YYYY HH:MM') : '' }}
          </div>
          <div v-if="currentUserIsAdmin"
               class="opacity-0 transition duration-200 group-hover:opacity-100">
            <ArchiveBtn class="ml-auto"
                        @confirm="deleteToken(item.id)"
                        revert-is-impossible
                        :submitted="busy"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import IconTrash from "@/components/icons/IconTrash";
import ArchiveBtn from "@/components/UI/ArchiveBtn";

export default {
  name: "APITokensList",
  components: {ArchiveBtn, IconTrash},
  data() {
    return {
      busy: false
    }
  },
  computed: {
    ...mapState('space/apiTokens', ['tokenList']),
    ...mapGetters('space', ['currentUserIsAdmin']),
  },
  methods: {
    ...mapActions('space/apiTokens', ['deleteAPIToken']),
    async deleteToken(id) {
      if (this.busy) return;
      try {
        this.busy = true;
        const res = await this.deleteAPIToken(id)
        if (res.body.success) this.$emit('update-list')
        else {
          console.error(res)
          this.$toasted.error(this.$t('errors.response'))
        }
      } catch (err) {
        console.error(err)
        this.$toasted.error(this.$t('errors.response'))
      } finally {
        this.busy = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'List of created token',
        nameLabel: 'Name',
        createdLabel: 'Created',
        lastUseLabel: 'Used'
      },
      ru: {
        listTitle: 'Список созданных токенов',
        nameLabel: 'Название',
        createdLabel: 'Создан',
        lastUseLabel: 'Использован'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.api-list-grid {
  @apply grid items-center;
  grid-template-columns:1fr 1fr 1fr 2.6rem;
}

.icon-btn {
  @apply flex items-center justify-center text-text-ternary
  border border-border rounded transition duration-200 cursor-pointer;
  width: 26px;
  height: 26px;


  &:hover {
    @apply bg-red-hover text-white border-red-hover;
  }
}
</style>